module.exports = __webpack_public_path__ + "static/img04-869058589b8faed532bcfcc19c22aa65.jpg";